export const formatDateFromDateSelector = (date) => {
  return`${date.slice(5,7)}/${date.slice(8)}/${date.slice(0,4)}`
}

export const formatPhoneNumber = (str) => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');

  //Check the phone
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }

  return null;
}

export const formatSSN = value => {
  return `***-**-${value.slice(5, 9)}`;
};

export const formatAccountNum = value => {
  if(value && value.length > 4) {
    const beginning = value.substring(0, value.length - 4);
    const beginningReplaced = beginning.replace( /\S/g, '*');
    const it = value.substring(value.length - 4);
    return beginningReplaced + it;
  }

  return value.replace( /\S/g, '*');
}

export const stripNewLine = value => {
   return value.replace(/\\n/g,'<br />'); //eslint-disable-line
}